<template>
  <v-card class="manage-box">
    <v-container grid-list-xl class="member-container">
      <v-layout row wrap>
        <v-flex v-if="memberCount > 0" class="cardbox">
          <v-card  elevation="8" v-for="memberLists in memeberList" :key="memberLists['id']">
            <v-container pb-4 grid-list-xl>
              <v-layout row wrap class="user-detailboxmain">
                <v-flex class="user-detailbox">
                  <v-list-item>
                    <v-list-item-avatar>
                      <span class="user-nameshortbox">{{
                        memberLists["name"].match(/\b(\w)/g).join('').toUpperCase().substring(0,2)
                      }}</span>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title
                        >
                        <p class="font-weight-medium user-icon-box" :class="memberLists['gender'] == ('OTHERS') || memberLists['gender'] ==  ('N/A') ? 'default-icon' :(memberLists['type'] == 'Father' || memberLists['type'] == 'Son'  ? 'male-icon':((memberLists['type'] == 'Mother') || (memberLists['type'] == 'Daughter') || (memberLists['type'] == 'Spouse') ? 'female-icon':'female-icon'))">
                          {{ memberLists["name"] }}
                        </p></v-list-item-title
                      >

                      <v-list-item-subtitle
                        >
                        <p class="font-weight-regular mail-icon" v-if="memberLists['email'] == 'N/A'">&nbsp;</p>
                        <p class="font-weight-regular mail-icon" v-if="memberLists['email'] !== 'N/A'">{{ memberLists["email"] }}</p>
                        </v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-flex>
                <v-flex class="userdetail">
                  <v-layout row wrap>
                    <v-flex class="s">
                      <p class="member-list-icons" :class="memberLists['type'] == 'Father' ? 'father':((memberLists['type'] == 'Mother') || (memberLists['type'] == 'Spouse') ? 'spouse':'child') ">{{ memberLists["type"] }}</p>
                    </v-flex>
                    <v-flex md6 sm6 xs12>
                      <p>Date of Birth</p>
                      <p class="font-weight-regular" v-if="memberLists['dob'] !== 'N/A'">{{ memberLists["dob"] | moment("DD MMM, YYYY")}}</p>
                      <p v-if="memberLists['dob'] == 'N/A'"></p>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-col class="memberbox-editbox">
                   <v-btn
                   class=""
                   outlined
                   fab
                   color="#F19700"
                   @click="showHide(memberLists['id'])"
                   >
                  <v-img
                       max-height="20"
                       max-width="20"
                       :src="three_dots"
                       :lazy-src="three_dots"
                   ></v-img>
                   </v-btn>
                   <div v-if="hideShow && (hideShowId == memberLists['id'])">
                     <v-btn @click="editMember(memberLists['id'])">
                       <v-img
                         max-height="20"
                         max-width="20"
                         :src="edit_pic"
                         :lazy-src="edit_pic"
                       ></v-img> Edit
                     </v-btn>
                     <v-btn @click="deleteMember(memberLists['id'])">
                       <v-img
                         max-height="23"
                         max-width="19"
                         :src=" delete_pic"
                         :lazy-src=" delete_pic"
                       > </v-img>Delete
                     </v-btn>
                   </div>  
               </v-col>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>

        <v-flex v-if="memberCount == 0" class="cardbox">
          <p>No record(s) found</p>
        </v-flex>
      </v-layout>
    </v-container>
    <v-btn class="orange-btn btn" @click="addNewMember">
      ADD NEW
    </v-btn>
  </v-card>
</template>

<script>
import axios from "axios";

export default {
  components: {},
  data: () => ({
    memeberList: "",
    hideShow:false,
    hideShowId:'',
    randomColor:'',
    classVariables:'',
    three_dots:process.env.VUE_APP_ROOT_ICONS_URL + 'three_dots.png',
    edit_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'edit.png',
    delete_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'delete.png',
    allow_add_family_member:'',
    memberCount:'',
  }),
  /*computed: {
       isPublic() {
           return this.$route.meta.isPublic ? true : false;
       }
     },*/

  beforeCreate() {

  },
  methods: {
    addNewMember() {

      this.allow_add_family_member == 0 ? 
       swal
        .fire({
          title: "You have already added max no. of members",
          showDenyButton: true,
          icon: 'warning',
         // showCancelButton: true,
          confirmButtonText: `YES`,
          //denyButtonText: `NO`
        }) : this.$router.push({ name: "AddNewMember" });
    },
    editMember(editId) {
      //alert(editId);
      //this.$loading(true)
      this.$router.push({ name: "EditNewMember", params: { id: editId } });
      //this.$loading(false)
    },
    deleteMember(deleteId) {
      swal
        .fire({
          title: "Are you sure, You want to delete this member?",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonColor: `#051d42`,
          confirmButtonText: `YES`,
          cancelButtonColor: `#f19700`,
          denyButtonText: `NO`
        })
        .then(result => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            Fire.$emit('membershipUpdate');
            let cognito_idp = this.authUser.cognito_idp;
            let api_token   = localStorage.getItem("api_token");


          var data = JSON.stringify({"member_id":deleteId,"aws_cognito_id":cognito_idp});

          var config = {
          method: 'post',
          url:process.env.VUE_APP_ROOT_API + 'delete-family-member',
          headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
          },
          data : data
          };

          axios(config)
          .then((response) => {
            Toast.fire({
                        icon: 'success',
                        title: 'Member deleted successfully.'
                  })
            Fire.$emit('updateMember');
            setTimeout(() => {
            this.$router.push({ name: 'dashboard' })
            }, 2000);
          })
          .catch(function (error) {
          //console.log(error);
          });
          } else if (result.isDenied) {
            Swal.fire("Changes are not saved", "", "info");
          }
        });
    },
    showHide(id){
      this.hideShowId = id;
      this.hideShow = this.hideShow ? false : true;
    },
    membershipData(){
      let cognito_idp = this.authUser.cognito_idp;
        let api_token = localStorage.getItem("api_token");

        //console.log(cognito_idp);

        var data = JSON.stringify({ aws_cognito_id: cognito_idp });

        var config = {
        method: "post",
        url: process.env.VUE_APP_ROOT_API + "get-family-member-list",
        headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        'Authorization': 'Bearer '+api_token,
        },
        data: data
        };

        axios(config)
        .then(response => {
        this.memeberList = response.data.data;
       // console.log('memberList',this.memeberList);
        this.memberCount = this.memeberList.length;
        //console.log('memberCount',this.memberCount);
        this.allow_add_family_member = response.data.allow_add_family_member;
        this.randomColor = ['yellow','pink','skyblue','#f19700','blue'];
        //this.memberList.push() 
        //const random = Math.floor(Math.random() * months.length);
        //console.log(this.memeberList);
        })
        .catch(error => {
        //console.log(error);
        });

    }
  },
  mounted(){
    this.membershipData();
    Fire.$on('updateMember', ()=>{
      this.membershipData();
    });
    this.membershipData();
  }
};
</script>
